export default {
  init() {
    // JavaScript to be fired on all pages
    //  ███████████████████████████████████████████████████████████████████████████████
    //  █████████████ Mobile Nav                                       ████████████████
    //  █████████████                                                  ████████████████
    $('header div.menu-btn').on('click', function () {
      //  Button Animation - behavior on click
      if ($('.menu-btn').hasClass('close')) {
        // hiding mobile menu
        $('.menu-btn').removeClass('close');
        $('.menu-btn').addClass('active');
        $('a.brand').removeClass('active');
        $('.header-primary-nav-container.mobile').removeClass('active');
        $('body').css('overflow', '');
      }
      else {
        //showing mobile menu
        $('.menu-btn').addClass('close');
        $('.menu-btn').addClass('active');
        $('a.brand').addClass('active');
        $('.header-primary-nav-container.mobile').addClass('active');
        $('body').css('overflow', 'hidden');
      }
    });

    //header submenu on hover
    $('div[has-children]').hover(function () {
      $(this).children('ul.submenu:eq(0)').addClass('active');
      $(this).children('ul.submenu:eq(0)').addClass('init');
    }, function () {
      $(this).children('ul.submenu:eq(0)').removeClass('active');
      $(this).children('ul.submenu:eq(0)').addClass('init');
    });


    //  clicking an input makes label smaller above
    var _load_gform_dynamic_label_scripts = true;
    if (_load_gform_dynamic_label_scripts) {
      // GFORM dynamic labels
      $('.gfield input:not([type=checkbox])').map(function (i, val) {
        if ($(val).val().length > 0) {
          $(this).closest('.gfield:not(._focused)').addClass('_focused');
        }
      })

      //listeners on section
      $('section').on('focusin', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        $(this).closest('.gfield').addClass('_focused');
      });

      $('section').on('focusout', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        setTimeout(function (that) {
          if ($(that).val().length == 0) {
            $(that).closest('.gfield').removeClass('_focused');
          }
        }, 10, this)
      });

      // listeners on lightbox form
      $('.lightbox-form-parent').on('focusin', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        $(this).closest('.gfield').addClass('_focused');
      });

      $('.lightbox-form-parent').on('focusout', '.gfield input:not([type=checkbox]), .gfield textarea', function () {
        setTimeout(function (that) {
          if ($(that).val().length == 0) {
            $(that).closest('.gfield').removeClass('_focused');
          }
        }, 10, this)
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    //  lightbox - *any* lightbox - close any lightbox when clicking close-popup
    $('.sf-lightbox').on('click', '.close-popup', function () {
      var _lightbox = $(this).closest('.sf-lightbox.active');
      $('body').css('overflow', '');

      _lightbox.removeClass('active');

      if (_lightbox.hasClass('download-lightbox-gated')) {
        var _form_container = _lightbox.find('.__form_container');
        var _form = _form_container.find('form');
        var _form_id = _form_container.attr('data-form-id');

        $.ajax({
          type: 'POST',
          url: '//' + document.domain + '/wp-admin/admin-ajax.php',
          data: {
            action: 'gs_getform',
            form_id: _form_id,
          },
          success: function (data) {
            _lightbox.find('.__form_container').html(data);
            _form = _lightbox.find('.__form_container').find('form');
            _form.attr('action', '/#gf_' + _form_id);
          },
        });
      }
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js